import React from "react";

const SITE_KEY = "0x4AAAAAAEL8wIGz-rw1Y0gh";
const SCRIPT_ID = "cloudflare-turnstile-api";

function ensureTurnstileScript() {
  return new Promise((resolve, reject) => {
    if (window.turnstile) return resolve(window.turnstile);
    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
    const started = Date.now();
    const timer = window.setInterval(() => {
      if (window.turnstile) {
        window.clearInterval(timer);
        resolve(window.turnstile);
      } else if (Date.now() - started > 10000) {
        window.clearInterval(timer);
        reject(new Error("Turnstile konnte nicht geladen werden"));
      }
    }, 100);
  });
}

export default function TurnstileWidget({ onToken, resetKey = 0, language = "de" }) {
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    let active = true;
    let widgetId = null;
    onToken("");

    ensureTurnstileScript()
      .then((turnstile) => {
        if (!active || !containerRef.current) return;
        widgetId = turnstile.render(containerRef.current, {
          sitekey: SITE_KEY,
          theme: "light",
          size: "flexible",
          language,
          callback: (token) => onToken(token),
          "expired-callback": () => onToken(""),
          "error-callback": () => onToken(""),
        });
      })
      .catch(() => onToken(""));

    return () => {
      active = false;
      if (widgetId !== null && window.turnstile) window.turnstile.remove(widgetId);
    };
  }, [language, onToken, resetKey]);

  return <div ref={containerRef} className="min-h-[65px] w-full" data-testid="turnstile-widget" />;
}
